export default __webpack_public_path__ + "static/media/深度学习.c6ec4ef5.jpg";